import classnames from 'classnames';
import React, { useState } from 'react';

import styles from './input.module.css';

function Input({
    type,
    onChange,
    name = '',
    value = '',
    required = false,
    label = '',
    id = null,
    style = undefined,
    placeholder = '',
    icon = null,
    icon2 = null,
    isVisiblePassword = false,
    readOnly = false,
    checked=false,
    min,
    max,

}) {
    const [focus, setFocus] = useState(false);

    const wrapperClass = classnames(styles.container, focus ? styles.focused : null);

    return (
        <div className={styles.container_input}>
            {label.length ? (
                <label className={styles.label} htmlFor={id}>
                    {label}
                </label>
            ) : null}

            <div className={wrapperClass} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}>
                <input
                 
                    className={styles.input}
                    type={type == 'password' ? (isVisiblePassword ? 'text' : 'password') : type || 'text'}
                    onChange={onChange}
                    name={name}
                    value={value}
                    required={required}
                    id={id}
                    style={style}
                    placeholder={placeholder}
                    min={min}
                    max={max}
                    readOnly={readOnly}
                    checked={checked}
                />
                {isVisiblePassword ? icon2 : icon}
            </div>
        </div>
    );
}

export default Input;
